let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("ej0dJ")]).then(() => parcelRequire('jtoCL'));